import api from './api';
import { getJwt } from '@app/helpers';
import Axios from 'axios';
import { trackPromise } from 'react-promise-tracker';


export interface EncerramentoFilter {
  numeroContrato?: string;
  fornecedoresId?: string[];
  status?: string[];
}

export interface RelatorioEncerramentoContratos {
  numeroContrato: string;
  fornecedor: string;
  status: string;
  avanco: number;
  trp?: string;
  trd?: string;
  nadaConsta?: string;
  teqcAssinado?: string;
}

export const searchValues = (values: EncerramentoFilter) => {
  return api.post<RelatorioEncerramentoContratos[]>('relatorios/encerramento', values, {
    disableNotification: 'true',
  });
};

export const exportExcel = (values: EncerramentoFilter) => api.downloadFile('relatorio/encerramentoContratos/excel', 'relatorioEncerramentoContratos.xls', values);


export const relatorioExportExcel = (values: EncerramentoFilter) => {

  let urlBase = window.location.origin;
  trackPromise(Axios.post(urlBase + `/api/relatorios/encerramentoContratos/excel`, values,
    {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {      
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "relatorio_enceramento.xlsx");
      link.setAttribute('id', 'downloadElementrelatorio_enceramento');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElementrelatorio_enceramento').outerHTML = '';
    }));
};